import React, { useState } from "react";
import img from "../../media/images/Full-Body-Wax-Price.png";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../store/cartSlice";

// import img2 from "../../media/images/femaleService/wax/chokowax01.jpg"

import icon1 from "../../media/images/Full-Body-Wax-Price-In-Delhi.png"
import icn1 from "../../media/images/hair trim icon.png"
import icn2 from "../../media/images/facial icon.png"
import icn3 from "../../media/images/waxing icon.png"
import icn4 from "../../media/images/men grooming icon.png"
import icn5 from "../../media/images/manicare icon.png"
import icn10 from "../../media/images/cleanup,facial,scrub icon.png"

import icn6 from "../../media/images/mens-full-body-grooming.png"
import icn7 from "../../media/images/mens-oxy-glow-package-icon.png"


import packageListData from './PackageList.json'

import packageServiceDataList  from "../../pages/femaleServices/FemaleServicePackage.json"

import ViewDetailsPackageOfFemale from "../../pages/femaleServices/ViewDetailsPackageOfFemale"



const LandingPackageComponent = ({h1, ActiveService,getHeadingRef, getSmHeadingref}) => {


  const [OpenviewDetails , setOpenViewDetails] = useState(null);

  const dispatch = useDispatch();

  const { cart } = useSelector(
    (state) => state.allCart
  );

  
  // console.log(cart,";;;;;;;;;;;;;;;;")
  
const CategoryPackageDataList = packageServiceDataList.services?.filter(e => e.category === ActiveService);

// console.log(CategoryPackageDataList, "::::::::::::::;;");


  return (
    <div>


      <div className="landing-package-new-service"> 


{/* ::::For Large Screen size :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
 */}


{CategoryPackageDataList?.length > 0 && (
  <div className="">
    {CategoryPackageDataList[0].subCategories.map((sub, subIndex) => (
      <div key={subIndex}>
        {/* Sub-category heading :::::::::::::::::::::*/}
        <h3 className="show-category-card-heading-of-services"
          ref={getHeadingRef(sub.subCategory)}
        >{sub.subCategory}</h3>

        <div className="landing-package-new-row">


          {sub.items.map((e, itemIndex) => (




// Items For DeshkTop views:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
// ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
<>
   <div className="landing-package-new-cols">

        <div className="landing-package-new-cols-top-time">
          <div className="time-value"><i class="fa-regular fa-clock"></i>
          {/* {e.duration} */}
              <div>MINS</div>
            </div> 
        
          <div className="triangle-shap"></div>
        </div>

        <div className="top-price-offer-box"> <span> ₹  {e.price}</span>  {e.mainPrice && <span className="offer-span-2"> ₹ {e.mainPrice}</span>  } 
        <span className="offer-span-3"> { Math.floor(( (e.mainPrice - e.price) / e.mainPrice) *100) }% Off</span>  </div>
        <div className="new-add-to-cart-desifn-btn-cont">
          <div   className={`new-add-to-cart-desifn-main-btn ${cart.find((a) => a._id === e._id) ? 'new-add-to-cart-desifn-main-btn-added' : ''}`}>

                {cart.find((a) => a._id === e._id) ? (
                  <div>Added</div>
                ) : (
                  <div onClick={() => dispatch(addToCart(e))}>
                    Add
                  </div>
                )}                              
          </div>
          <div className="new-add-to-cart-desifn-sm-container"> <div className="new-add-to-cart-desifn-sm-triangle">  </div></div>
        </div>
       <div  className="package-new-cols-img" ><img src={e.image}></img> </div> 
    
    <div className="landing-new-style-card-shadow">
<div className="landing-new-style-card-text-cont">
  <div className="landing-new-style-card-text-package-text">
    <h5>{e.fullName}</h5>
    <p> {e.serviceDetails}</p>


  </div>


  {/* For view Details condition :::::::::::::::::::::::::::::::::::::::::::::::::
::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}

  {
   e.viewPackage &&
      <div className="View-details-services-box" onClick={()=>setOpenViewDetails(e._id)}>
  <div className="View-details-services-btn">  View details </div>
          <div className="new-add-to-cart-desifn-sm-container"> <div className="new-add-to-cart-desifn-sm-triangle">  </div></div>
   </div>
  }
</div>



{

  OpenviewDetails ===e._id ?
  <ViewDetailsPackageOfFemale   e={e}  setOpenViewDetails={setOpenViewDetails} />
  :""
}

    </div>
      </div>



 {/* Items For sm Phone views:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
 ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}

<div className="female-sm-new-package-inner-row-content">

<div className="female-sm-package-data-card-content-row">
  <div> 
    <div className="female-sm-serice-packages-image"><img src={e.image} alt="img_sf1"></img> </div>
  </div>

  <div className="female-sm-package-data-card-text-details-cols">
    <div className="female-sm-package-data-card-top-prices"> 

      <div className="female-sm-package-data-card-top-prices-cols1">
        <div>  <span> ₹  {e.price} </span>  {e.mainPrice && <span> ₹  {e.mainPrice}</span> } </div>
      </div>
      <div className="female-sm-package-data-card-top-prices-cols2">
         <div> {e.offer && <span>  { Math.floor(( (e.mainPrice - e.price) / e.mainPrice) *100) }% Off</span> }  </div>
        <div>
          {/* <i class="fa-solid fa-clock"></i> {e.duration}MIN */}
          </div>
      </div>

    </div>

    <div className={`female-sm-services-book-now-btn ${cart.find((a) => a._id === e._id) ? 'female-sm-services-book-now-btn-active' : ''}`} >
      
      
                {cart.find((a) => a._id === e._id) ? (
                  <div>Added</div>
                ) : (
                  <div onClick={() => dispatch(addToCart(e))}>
                    Add
                  </div>
                )} 
    </div>
  </div>
</div>

<div className="female-sm-services-details-name-text-row">{e.fullName}</div>
    <p> {e.serviceDetails}</p>


{/* For view Details condition :::::::::::::::::::::::::::::::::::::::::::::::::
::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}
  {

   e.viewPackage &&

<div> <div className="view-package-fm-details-sm-button"><button onClick={()=> setOpenViewDetails(e._id)}> View Details </button> </div></div>
  }

{

  OpenviewDetails ===e._id ?
  <ViewDetailsPackageOfFemale   e={e}  setOpenViewDetails={setOpenViewDetails} />
  :""
}

</div>

</>




          ))}
        </div>
      </div>
    ))}
  </div>
)}














      </div>




      {/* New package for phone  view :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
      :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::*/}


      <div className="sm-landing-new-package">

{/* 
{
      packageListData.map(e=>(

      
        <div   className="sm-landing-new-package-row">


          <div className="sm-main-landing-new-package-row">

            <div className="hhhh">
              <div className="sm-landing-new-package-img home-package-icon">
                 
                 <img title=" Best body wax artist near me" src={e.iconName} alt="icon" />
                 </div>
            </div>
              <div className=""> 
                <div className="sm-package-heading">{e.fullName}</div>
                <div className="sm-desc-package">{e.packagePoints}</div>
             
             
          <div className="sm-package-offer-time-details-cont">     <div className="sm-package-offer-price">   <span>RS.{e.mainPrice}</span> <span>{e.price}</span>    </div>   <div className="sm-package-time"> <i class="fa-regular fa-clock"></i> {e.time} MINS</div>  </div>
          
                   {cart.find((a) => a._id === e._id) ? (
                                       <div className="sm-new-package-book-btn price-page-content-col-list-button-addded">Added</div>
                                     ) : (
                                       <div className="sm-new-package-book-btn" onClick={() => dispatch(addToCart(e))}>
                                         Add
                                       </div>
                                     )}
          
              </div>
                
                
          </div>
     
      
        </div>

      ))      
} */}


{/* {

  CategoryPackageDataList?.length >0 && (

<div className="female-sm-new-package-main-content">

{
  CategoryPackageDataList[0].subCategories.map((sub1,subIndex)=>(

 <div className="" key={subIndex}> 

     <h3 className="show-category-card-heading-of-services"
        
        >Heading</h3> 


{
  sub1.items.map((e,itemIndex)=>(
<div className="female-sm-new-package-inner-row-content">

<div className="female-sm-package-data-card-content-row">
  <div> 
    <div className="female-sm-serice-packages-image"><img src="https://www.swagmee.com/media/catalog/product/cache/3a8605407f26197eb12d4b9c6ca6d352/e/l/elegant-rica-wax-_full-arms-_-full-legs-_-underarms-_-shapeup_-_-bleach_d-tan-_face-_-neck_-_-10-min-head-massage--_999_.jpg" alt="img_sf1"></img> </div>
  </div>

  <div className="female-sm-package-data-card-text-details-cols">
    <div className="female-sm-package-data-card-top-prices"> 

      <div className="female-sm-package-data-card-top-prices-cols1">
        <div>  <span> ₹  {e.price} </span>  {e.mainPrice && <span> ₹  {e.mainPrice}</span> } </div>
      </div>
      <div className="female-sm-package-data-card-top-prices-cols2">
         <div> {e.offer && <span> {e.offer}% Off</span> }  </div>
        <div><i class="fa-solid fa-clock"></i> {e.duration}MIN</div>
      </div>

    </div>

    <div className={`female-sm-services-book-now-btn ${cart.find((a) => a._id === e._id) ? 'new-add-to-cart-desifn-main-btn-added' : ''}`} >
      
      
                {cart.find((a) => a._id === e._id) ? (
                  <div>Added</div>
                ) : (
                  <span onClick={() => dispatch(addToCart(e))}>
                    Add
                  </span>
                )} 
    </div>
  </div>
</div>

<div className="female-sm-services-details-name-text-row">{e.fullName}</div>

</div>

  ))
}
</div>

  ))
}



</div>

  )
} */}



      </div>
{/* 
       <div id="how-we-deliver">

            
                <a href="#services" className="landing-page-button-web-yellow landing-page-button-black  book-service-now-btn-package-gap">
                  Book Service Now
                  </a>

                  <a href="#services" className="landing-page-button-mobile-yellow landing-page-button-black book-service-now-btn-package-gap">
                  Book Service Now
                  </a>
</div> 
              */}

<div id="why-us"></div>

    </div>
  );
};

export default LandingPackageComponent;
